import React, { FC } from "react";
import SectionCTA from "../../SectionCTA/SectionCTA";
import { ISectionCTAsGroup } from "../ISectionCTAsGroup";
import { classNames } from "../../../../../utils/common/styling";
import { styles } from "./SimpleSectionCTAsGroup.styles";

export const SimpleSectionCTAsGroup: FC<ISectionCTAsGroup.IProps> = ({
  value,
  sections,
  ctaProps,
  onClick,
  showActions,
  onEdit,
  className,
}) => {
  const visibleSections = sections?.filter((section) => !section.hide) || [];

  return (
    <div className={classNames(styles.root, className)}>
      {visibleSections.map((section, index) => {
        const { label, icon, id, sectionData } = section;

        return (
          <div key={id}>
            {/* Divider BEFORE item (skip first) */}
            {index !== 0 && <div className={styles.divider} />}

            <SectionCTA
              label={label}
              icon={icon}
              isChannelLocked={sectionData?.is_channel_locked}
              active={value === id}
              onClick={(e) => onClick?.({ index, section, event: e })}
              showActions={showActions}
              onEdit={(e) => onEdit?.({ index, section, event: e })}
              {...ctaProps}
            />
          </div>
        );
      })}
    </div>
  );
};
